import axios, { AxiosResponse } from "axios";
import { General } from "./general";
import { Pais } from "../models/pais.model";
import { PaisJefe } from "../models/paisJefe.model";

export function PaisesService(props?: any) {
    const getPaises = async (): Promise<AxiosResponse<Pais[]>> => {
        return axios.get<Pais[]>(`${General.API_URL}/GetPaises`);
    }
    const getPaisesConJefe = async (): Promise<AxiosResponse<PaisJefe[]>> => {
        return axios.get<PaisJefe[]>(`${General.API_URL}/GetPaisesConJefeEquipo`);
    }
    function getPaisesPorId(value: number) {
        return axios.get<PaisJefe>(`${General.API_URL}/GetPais/${value}`);
    }
    const updatePaises = (body: PaisJefe): Promise<any> => {
        return axios.put(`${General.API_URL}/UpdatePaises`, body)
    }
    const createPaises = (body: PaisJefe): Promise<any> => {
        return axios.post(`${General.API_URL}/SavePaises`, body)
    }

    return (
        {
            getPaises,
            getPaisesConJefe,
            getPaisesPorId,
            updatePaises,
            createPaises
        }
    );

}